/**
 * Rewrite Unsplash image URLs to a specific rendered width so we don't ship
 * full-resolution photos to small card thumbnails. Non-Unsplash URLs are
 * returned unchanged.
 */
export function sizedImage(url: string, width: number): string {
  if (!url) return url;
  if (!/images\.unsplash\.com/.test(url)) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("w", String(width));
    if (!u.searchParams.has("q")) u.searchParams.set("q", "70");
    if (!u.searchParams.has("auto")) u.searchParams.set("auto", "format");
    if (!u.searchParams.has("fm")) u.searchParams.set("fm", "webp");
    return u.toString();
  } catch {
    return url;
  }
}
